import React, { useContext, useMemo } from 'react';
import { VenueAnalysisVenueData } from 'widgets/venueAnalysis/venueAnalysisAggregatedData';
import AppContext from 'app/AppContext';
import { OrderFillsCapsuleData } from '../useOrderFillsCapsuleData';
import {
    OrderFillsCapsuleStrategy,
    useOrderFillsCapsuleStrategy,
} from '../orderFillsCapsuleStrategy';

export interface OrderFillsCapsuleContentValuesProps {
    data: OrderFillsCapsuleData;
}

export function OrderFillsCapsuleContentValues(
    props: OrderFillsCapsuleContentValuesProps
) {
    const {
        data: { orderData },
    } = props;
    const strategy = useOrderFillsCapsuleStrategy();

    const rows = useMemo(
        () =>
            orderData.map((v) => (
                <VenueRow venue={v} key={v.micCode} strategy={strategy} />
            )),
        [orderData, strategy]
    );

    return <div className="OrderFillsCapsuleContentValues">{rows}</div>;
}

function VenueRow(props: {
    venue: VenueAnalysisVenueData;
    strategy: OrderFillsCapsuleStrategy;
}) {
    const { venue, strategy } = props;
    const { percent } = venue;
    const { numberFormat } = useContext(AppContext);
    const percentText = `${numberFormat.n0(percent)}%`;

    return (
        <div className="venue-row">
            <div className="label">
                {strategy.renderLabel(venue, percentText)}
            </div>
            <div className="value">{percentText}</div>
        </div>
    );
}
